import { isEssentialPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { essentialTabReloadedThunk } from 'state/essential/thunks';
import type { EpicWithThunk } from 'state/state.common';

export function fillTabContentInEssentialScreenEpic(): EpicWithThunk {
  return (action$, _state$) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ tabContent }) => isEssentialPersistedTabContent(tabContent)),
      mergeMap(({ tabId, tabContent }) => {
        if (!isEssentialPersistedTabContent(tabContent)) {
          return EMPTY;
        }

        return of(essentialTabReloadedThunk(tabId, tabContent));
      }),
    );
}
